export default __webpack_public_path__ + "7faa6e5a9038b3c617a8fcd163549307.png";